import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalOptions } from 'ngx-bootstrap/modal';
import { Key } from 'ts-keycode-enum';
import { BaseComponent } from '../base-component';
import { Expedition } from '../comun/recipient-services/expedition';
import { PackageInfo } from '../comun/recipient-services/package-info';
import { ChangeType } from '../enums/change-type.enum';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { MultiplePiecesModalComponent } from '../multiple-pieces-modal/multiple-pieces-modal.component';
import { NumberConflictModalComponent } from '../number-conflict-modal/number-conflict-modal.component';
import { PackageTrackingModalComponent } from '../package-tracking-modal/package-tracking-modal.component';
import { ExceptionHttp } from '../services/api.service';
import { ExpeditionsService } from '../services/expeditions.service';
import { LanguageService } from '../services/language.service';
import { CategoriasGoogleAnalytics, paths } from '../services/sesion.service';


@Component({
  selector: 'common-retry-search',
  templateUrl: './retry-search.component.html',
  styleUrls: ['./retry-search.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetrySearchComponent extends BaseComponent implements OnInit {
  expedition: Expedition;
  contracted = true;
  collapseDetailShipping = true;
  collapsePackage = true;
  expeditionNumber: string;
  readonly regexExpedition = /[\t]/g;

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private langService: LanguageService,
    private service: ExpeditionsService) {
    super();

  }

  @HostListener('window:keydown', ['$event']) keydown(e: KeyboardEvent) {
    if (e.keyCode == Key.F4) {
      this.contracted = !this.contracted;
      this.cdr.detectChanges();
    }
  }
  ngOnInit() {
    this.expedition = this.sesion.expedition$.getValue();
    this.expeditionNumber = this.sesion.numeroExpedicionBuscado;
    this.cdr.detectChanges();
  }
  async searchExpedition() {
    try {
      this.sesion.enviarEventoGoogleAnalitics(CategoriasGoogleAnalytics.ConsultaExpedicion, 'Acceso');
      this.sesion.tipoCambioActivo = ChangeType.Ninguno;

      try {
        const expedition = await this.service.search(this.expeditionNumber).toPromise();
        if (!expedition) {
          this.sesion.expedition$.next(null);
          this.sesion.numeroExpedicionBuscado = this.expeditionNumber;
          this.router.navigate([paths.noData[this.sesion.idioma$.getValue()]]);
          return;
        } else if (expedition.NoRS) {
          this.sesion.numeroExpedicionBuscado = expedition.ExpeditionNumber;
          this.sesion.expedition$.next(expedition);
          await this.router.navigate([paths.withoutModification[this.sesion.idioma$.getValue()]]);
          return;
        }

        this.sesion.numeroExpedicionBuscado = expedition.ExpeditionNumber;

        this.collapsePackage = true;
        this.expedition = expedition;
        this.detailPackages = null;
        const datosRuta = [paths.modificarEnvio[this.sesion.idioma$.getValue()], expedition.ExpeditionNumber];
        await this.router.navigate(datosRuta, { queryParamsHandling: 'merge' });
        this.sesion.expedition$.next(this.expedition);
        this.contracted = true;
      } catch (error) {
        const mistakeHttp = (error as ExceptionHttp);
        if (mistakeHttp && mistakeHttp.status == 409) {
          this.sesion.numeroExpedicionBuscado = this.expeditionNumber;
          try {
            let bultos = await this.sesion.searchExpeditionByReference(this.expeditionNumber);
            if (bultos && bultos.length > 0) {
              let modalOptions = <ModalOptions<MultiplePiecesModalComponent>>{
                initialState: {
                  bultos: bultos
                }
              };
              MultiplePiecesModalComponent.show(modalOptions);
            } else {
              NumberConflictModalComponent.show();
            }
          } catch (err) {
            ErrorModalComponent.show(err);
          }
        } else {
          throw error;
        }
      }
    } catch (err) {
      ErrorModalComponent.show(err);
    }
  }
  onInitializedSharedResources() {

    this.cdr.detectChanges();
  }
  detailPackages: Array<PackageInfo>;
  async toggleCollapsePackages() {
    if (this.collapsePackage) {
      if (this.detailPackages == null) {
        try {
          this.detailPackages = await this.service.detailPackages(this.expedition.TLGNumber).toPromise();
          this.sesion.enviarEventoGoogleAnalitics(CategoriasGoogleAnalytics.ConsultaExpedicion, "Bultos")
        } catch (error) {
          ErrorModalComponent.show(error);
          return;
        }
      }
    }
    this.collapsePackage = !this.collapsePackage;
    this.cdr.detectChanges();
  }

  showDetailPackage(bulge: PackageInfo) {
    PackageTrackingModalComponent.show(bulge);
  }

  get number(): string {
    if (this.expedition && this.expedition.TLGNumber && this.expedition.TLGNumber.length > 5) {
      return this.expedition.TLGNumber.substring(0, 2) + this.expedition.TLGNumber.substring(5)
    } else {
      return this.expedition.ExpeditionNumber;
    }
  }
  get HomeRoute(): string {
    return !this.expedition || this.expedition.ProductType == 'B2C' ? (this.langService.instant('Shared.HomeRoute').startsWith('./') ? this.langService.instant('Shared.HomeRoute') : '/' + this.langService.instant('Shared.HomeRoute')) : this.sesion.urlBussines;
  }

  private sentEventDetails = false;
  clickDetalle() {
    this.collapseDetailShipping = !this.collapseDetailShipping
    if (!this.sentEventDetails) {
      this.sesion.enviarEventoGoogleAnalitics(CategoriasGoogleAnalytics.ConsultaExpedicion, "Detalles")
      this.sentEventDetails = true;
    }
  }
  private sentEventBack = false;
  clickBack() {
    if (!this.sentEventBack) {
      this.sesion.enviarEventoGoogleAnalitics(CategoriasGoogleAnalytics.ConsultaExpedicion, "Atras")
      this.sentEventBack = true;
    }
  }
}
